import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/common/base/base.component';
import { ResourceSummary, ResourceUserRelation } from 'src/app/components/catalogs/beamline-catalog/resource/resources';
import { ResourceBeamlineStaffCatalog } from '../beamline-staff';

@Component({
  selector: 'beamline-staff-main-panel',
  templateUrl: './beamline-staff-main-panel.component.html',
  styleUrls: ['./beamline-staff-main-panel.component.scss']
})
export class BeamlineStaffMainPanelComponent extends BaseComponent implements OnInit {

  @Input() filter?: string;
  @Input() beamlines?: ResourceBeamlineStaffCatalog[] = [];

  public resourceSummary?: ResourceSummary;
  public RURAux?: ResourceUserRelation;

  public loading = false;

  public displayedColumnsSupervisor: string[] = ['supervisorName', 'endstation', 'branchline'];
  public displayedColumnsScientist: string[] = ['scientistName', 'endstation', 'branchline'];
  public displayedColumnsAlternateScientist: string[] = ['alternateScientistName', 'endstation', 'branchline'];

  public valueFilter = '';
  public emptyBeamlineStaffMessage = '';

  id = '';
  public filteredBeamlines?: any[];

  ngOnInit() {
    this.emptyBeamlineStaffMessage = this.getMessage('beamline_Staff_Catalog').description ?? 'Without assigning supervisors or scientists to the resource';
  }

  /**
   * Updates filtered beamlines when input changes, filtering by beamline name, staff usernames, and facility associations.
   * @param changes The input property changes.
   */
  ngOnChanges(changes: SimpleChanges): void {
    // Normalize filter to lowercase for case-insensitive matching
    const filter = this.filter ? this.filter?.toLowerCase() : null;

    // Filter beamlines by name, staff, and facility attributes; otherwise return all beamlines
    this.filteredBeamlines = filter ?
      this.beamlines?.filter(b =>
        b.beamlineName.toLowerCase().includes(filter) ||
        b.supervisors.some(u => u.userName.toLowerCase().includes(filter)) ||
        b.scientists.some(u => u.userName.toLowerCase().includes(filter)) ||
        b.alternateScientists.some(u => u.userName.toLowerCase().includes(filter)) ||
        b.supervisors.some(u => u.endStations.includes(filter)) ||
        b.supervisors.some(u => u.branchLines.includes(filter)) ||
        b.scientists.some(u => u.endStations.includes(filter)) ||
        b.scientists.some(u => u.branchLines.includes(filter)) ||
        b.alternateScientists.some(u => u.endStations.includes(filter)) ||
        b.alternateScientists.some(u => u.branchLines.includes(filter))
      )
      : this.beamlines;
  }

  /**
   * Clears and resets the auxiliary ResourceUserRelation data structure.
   * Reinitializes all related collections to empty arrays.
   */
  clearRURAuxData() {
    // Reset RURAux to a new instance
    this.RURAux = new ResourceUserRelation();
    // Clear all associated collections
    this.RURAux.resourceUserRelations = [];
    this.RURAux.joinEndstations = [];
    this.RURAux.joinBranchlines = [];
  }

  clearFilter() {
    this.valueFilter = '';
    this.filteredBeamlines = this.beamlines;
  }

  /**
   * Scrolls the page to a specific beamline element using smooth scrolling behavior.
   * @param b The beamline catalog object containing the beamline ID to scroll to.
   */
  scrollToBeamline(b: ResourceBeamlineStaffCatalog) {
    // Construct the element ID from the beamline ID
    const elem = 'bl' + b.beamlineID;
    // Retrieve the DOM element
    const divElement = document.getElementById(elem);
    // Scroll into view if element exists
    if (divElement)
      divElement.scrollIntoView({ behavior: 'smooth' });
  }
}
